<template>
  <div class="related-list">
    <div class="ds-grid">
      <h3 class="ds-grid__col ds-heading-small md-heading ds-margin-bottom-24">
        {{ title }}
      </h3>
    </div>
    <div v-if="loading"
      class="ds-display-flex ds-width-full ds-align-items-center ds-justify-content-center ds-padding-top-24">
      <Loading />
    </div>
    <div class="ds-grid" v-else>
      <div v-for="item in items" :key="item.id"
        class="ds-grid__col ds-grid__col--12 ds-md-grid__col--4 ds-lg-grid__col--3 ds-padding-bottom-12">
        <PaymentMethodsCard :link="item.url" :image="item.image?.original" :title="item.name"
          :subtitle="item.paymentMethodTypesNames" :description="item.shortDescription" />
      </div>
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
  title: { type: String, required: true },
  items: { type: Array, required: true },
  loading: { type: Boolean, default: false }
})
</script>
<script>
export default {
  name: 'PaymentMethodRelatedList',
}
</script>

<style scoped lang="scss">
@import 'awds/foundation-vars.scss';
@import 'awds/foundation-mixins.scss';

.related-list {
  // margin-bottom = wanted - card padding
  margin-bottom: calc(#{$spacing-48} - #{$spacing-12});

  @include screen('medium') {
    margin-bottom: calc(#{$spacing-96} - #{$spacing-12});
  }
}
</style>
